"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports.StyledImage = exports.StyledImageContainer = exports.StyledCallToActionWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = require("../Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", "\n  font-size: 1em;\n\n  @media screen and (min-width: ", ") {\n    width: ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 230px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 80px;\n\n  @media screen and (min-width: ", ") {\n    height: 480px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledCallToActionWrapper = _styledComponents.default.div(_templateObject());

exports.StyledCallToActionWrapper = StyledCallToActionWrapper;

var StyledImageContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
});

exports.StyledImageContainer = StyledImageContainer;

var StyledImage = _styledComponents.default.img(_templateObject3());

exports.StyledImage = StyledImage;
var StyledButton = (0, _styledComponents.default)(_Button.Button)(_templateObject4(), function (props) {
  return props.width;
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
}, function (props) {
  return props.width;
});
exports.StyledButton = StyledButton;